import { patchFollowPreferences } from '@gonfalon/openapi/operations/patchFollowPreferences';
import { getQueryClient } from '@gonfalon/react-query-client/getQueryClient';

import { createMutationHook } from '../internal/createMutationHook';
import { followPreferences } from '../queries/followPreferences';

export const useUpdateFollowPreferences = createMutationHook(patchFollowPreferences, {
  onSuccess: async () => {
    const queryClient = getQueryClient();
    await queryClient.invalidateQueries({ queryKey: followPreferences.detail.queryKey });
  },
});
